import React from 'react';
import Folders from './RightSideMenuElements/Folders';
import LoginLink from './RightSideMenuElements/LoginLink';
import MenuDropdown from './RightSideMenuElements/MenuDropdown';
import PlanCtaButton from './RightSideMenuElements/PlanCta';
import StoryboardCtaButton from './RightSideMenuElements/StoryboardCta';
import PricingLink from './RightSideMenuElements/PricingLink';
const RightSideMenu = ({ isLoggedIn = false, isIpAuth, user, userInitials, account, showFavorites, planCta, isUserOnStarterPlan, isUserOnGrowthPlan, remainingExports, organizationName, shouldShowEnterpriseExperience, starterPlanRemainingDownloads, storyboardEnabled, logger, BetaBadgeClasses, imagesUrl, }) => {
    let showPlanCta = false;
    const menuParams = {
        isUserOnStarterPlan,
        isUserOnGrowthPlan,
        shouldShowEnterpriseExperience,
        organizationName,
        user,
        userInitials,
        starterPlanRemainingDownloads,
        remainingExports,
        account,
    };
    showPlanCta = planCta && !!planCta.id;
    return (<>
      <div className="mainNav-siteMenu w-full h-8 justify-start items-center xl:gap-6 lg:gap-3 inline-flex hidden font-inter lg:flex xl:ml-4 ">
        {!user && (<>
            <div className="justify-start items-center gap-1 flex">
              <LoginLink />
            </div>
            <div className="justify-start items-center gap-1 flex">
              <PricingLink />
            </div>
          </>)}

        {storyboardEnabled && (<StoryboardCtaButton logger={logger} BetaBadgeClasses={BetaBadgeClasses} imagesUrl={imagesUrl}/>)}

        {showFavorites && <Folders logger={logger}/>}

        {isLoggedIn && !isIpAuth && <MenuDropdown {...menuParams}/>}

        {showPlanCta && (<div>
            <PlanCtaButton planCta={planCta} logger={logger} mobile={false}/>
          </div>)}
      </div>
      <div className="mobileXsell lg:hidden flex items-center justify-end space-x-2">
        {showPlanCta && (<PlanCtaButton planCta={planCta} logger={logger} mobile={true}/>)}
      </div>
    </>);
};
export default RightSideMenu;
